import React, { useEffect } from 'react';
import { AuthRelay } from '../components/AuthLayout';

export default function KcbPopup() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const rslt_name = params.get('rslt_name');
    const tel_no = params.get('tel_no');
    const birthday = params.get('birthday');
    const sex_cd = params.get('sex_cd');
    const di = params.get('di');
    const eci = params.get('eci');
    const authType = params.get('authType') || 'password_reset';
    const userIndex = params.get('userIndex');
    
    // 디버깅 로그 추가
    // console.log('[KcbPopup] URL 파라미터 확인:');
    // console.log('- rslt_name:', rslt_name);
    // console.log('- tel_no:', tel_no);
    // console.log('- birthday:', birthday);
    // console.log('- sex_cd:', sex_cd);
    // console.log('- di:', di);
    // console.log('- eci:', eci);
    // console.log('- authType:', authType);
    // console.log('- userIndex:', userIndex);
    // console.log('- 모든 파라미터 키:', Array.from(params.keys()));
    // console.log('- 현재 URL:', window.location.href);
    
    // 1. 인증 결과가 있으면 부모창에 전달
    if (rslt_name && tel_no) {
      if (window.opener) {
        window.opener.postMessage({ 
          rslt_name, 
          tel_no, 
          birthday, 
          sex_cd, 
          di, 
          eci, 
          authType, 
          userIndex 
        }, window.location.origin);
        setTimeout(() => window.close(), 500);
      }
      return;
    }
    // 2. 현재 경로가 절대경로가 아니면 절대경로로 이동 (내부 라우트 보장)
    const { protocol, hostname, pathname } = window.location;
    const origin = `${protocol}//${hostname}`;
    const expectedPath = `/cert/kcb/popup2`;
    if (!pathname.startsWith(expectedPath)) {
      window.location.replace(`${origin}${expectedPath}${window.location.search}`);
      return;
    }
    // 3. 인증 결과가 없고, 내부 라우트가 맞으면 실제 KCB 인증 URL로 이동
    const externalUrl = `https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb${window.location.search}`;
    window.location.replace(externalUrl);
  }, []);

  return <AuthRelay title="휴대폰 본인인증 진행 중..." description="잠시만 기다려 주세요. 인증 기관 화면으로 넘어갑니다." />;
} 